export const GenerateSidesSuccessModal: string = 'GenerateSidesSuccessModal';
